class HeaderUseCase {
    constructor(headerRepo) {
        this.headerRepo = headerRepo;
    }
    async getMenuData() {
        const headerDTOList = await this.headerRepo.getMenuData();
        return headerDTOList;
    }
}
export default HeaderUseCase;
